import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../Component/features/UserSlice";

export default configureStore({
  reducer: {
    user: userReducer,
  },
});
